/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:56
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-05 12:04:24
 */
const getters = {
  serverName: state => state.user.serverName,
  roleName: state => state.user.roleName,
  serverRoleList: state => state.user.serverRoleList,
  roleId: state => state.user.roleId,
  appId: state => state.user.appId,
  appName: state => state.user.appName,
  lang: state => state.lang
}

export default getters
